import PropTypes from 'prop-types';
import React from 'react';
import { JsonView } from '../WildSky/JsonView';
import { Button } from '@material-ui/core';

import { RemoteButton } from '../RemoteButton';

function StringToObject(save) {
    try {
        const o = JSON.parse(save);
        for (let key in o) {
            if (typeof o[key] === 'string') {
                try {
                    const valueAsObject = JSON.parse(o[key]);
                    o[key] = valueAsObject;
                } catch (e) {
                    // Ignore this field.
                }
            }
        }
        return o;
    } catch (e) {
        return { error: e };
    }
}

class MapSaveDataEditor extends React.PureComponent {
    state = { edit: false, value: null };

    startEdit = () => {
        this.setState({ edit: true, value: JSON.stringify(StringToObject(this.props.save.save), null, 4) });
    }

    cancelEdit = () => {
        this.setState({ edit: false, value: null });
    }

    onEdit = e => {
        this.setState({ value: e.target.value });
    }

    postEdit = async () => {
        const data = JSON.parse(this.state.value);
        for (let key in data) {
            if (typeof data[key] === 'object' && data[key] !== null) {
                data[key] = JSON.stringify(data[key]);
            }
        }
        const save = JSON.stringify(data);

        const response = await fetch('/api/data/update/user_backup_data', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: { _id: this.props.userId },
                update: {
                    $set: {
                        [`map_save_data.${this.props.index}`]: {
                            key: this.props.save.key,
                            save,
                            // Append an empty space so it will be treated as string instead of date.
                            timestamp: new Date().toISOString() + ' ',
                            sequence_counter: this.props.save.sequence_counter + 1000000,
                        }
                    }
                },
            }),
        });
        const result = await response.json();
        if (result.error) {
            console.error(result);
            alert(result.error);
        } else {
            this.props.onReload();
        }
    }

    render() {
        const { save } = this.props;
        if (this.state.edit) {
            let error = null;
            let data = null;
            try {
                data = JSON.parse(this.state.value);
            } catch (e) {
                error = e.toString();
            }
            return (
                <div>
                    <div>
                        <div style={{ color: 'red' }}>{error}&nbsp;</div>
                        <textarea rows={25} cols={120} value={this.state.value} onChange={this.onEdit}></textarea>
                    </div>
                    {
                        !error &&
                        <RemoteButton name="Update" onStart={this.postEdit}>
                            <JsonView value={data} />
                        </RemoteButton>
                    }
                    <Button variant="contained" onClick={this.cancelEdit}>Cancel</Button>
                </div>
            );
        }
        return (
            <div>
                <JsonView value={StringToObject(save.save)} />
                <Button variant="contained" onClick={this.startEdit}>Edit</Button>
            </div>
        );
    }
}

MapSaveDataEditor.propTypes = {
    userId: PropTypes.string,
    index: PropTypes.number,
    save: PropTypes.object,
    onReload: PropTypes.func,
};

export class UserBackupData extends React.PureComponent {
    state = {
        loading: true,
        data: null,
        error: null,
    }
    componentDidMount() {
        this.reload();
    }

    onReload = () => {
        this.setState({ loading: true });
        this.reload();
    }

    reload() {
        fetch(`/api/data/get/user_backup_data/${this.props.userId}`)
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ loading: false, error: result.error });
                } else {
                    this.setState({ loading: false, data: result.result });
                }
            });
    }

    render() {
        if (this.state.loading) {
            return <div>Loading...</div>;
        }
        if (this.state.error) {
            return <div>{this.state.error}</div>;
        }
        return (
            <div>
                {
                    this.state.data.map_save_data &&
                    this.state.data.map_save_data.map((save, index) => (
                        <MapSaveDataEditor key={save.key} userId={this.props.userId} index={index} save={save} onReload={this.onReload} />
                    ))
                }
                {
                    !this.state.data.map_save_data &&
                    <JsonView value={this.state.data} />
                }
            </div>
        );
    }
}

UserBackupData.propTypes = {
    userId: PropTypes.string.isRequired,
};
